<template>
	<el-dialog v-model="visible" title="日志" v-bind="$attrs" width="50%" draggable>
		<div style="margin: 20px auto 0; padding: 0 20px; height: 30vh; overflow: auto" v-loading="loading">
			<div class="box" v-for="(item, index) in list" :key="index">
				{{ item }}
			</div>
		</div>
		<template #footer> </template>
	</el-dialog>
</template>
<script>
import { getAction, postAction } from "@/api/manage";
import { ElMessage } from "element-plus";
export default {
	name: "rz-dialog",
	data() {
		return {
			visible: false,
			loading: false,
			list: [],
		};
	},
	methods: {
		open(options) {
			console.log("rzDialog.open(): options=", options);
			this.list = [];
			this.visible = true;
			this.loading = true;
			getAction(options.url, options.params)
				.then((res) => {
					console.log("rzDialog.open().getAction().then: res=", res);
					if (res.code == 200) {
						this.list = res.data;
					} else {
						ElMessage.error(res.message || res.message);
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		hide() {
			this.visible = false;
		},
	},
};
</script>
<style scoped>
.box {
	font-size: 14px;
	line-height: 14px;
}
::-webkit-scrollbar {
	width: 5px;
}
::-webkit-scrollbar-thumb {
	background-color: #7da7f0;
}
::-webkit-scrollbar-track {
	background-color: #fff;
}
</style>
